import { isEmpty } from "lodash";
import moment from "moment";
import { useHntMarket } from "../../utils/useHntMarket";

const HistoricalDataChartTooltipWithCurrency = ({ active, payload }: any) => {
  const { displayInCurrency } = useHntMarket();

  if (active && !isEmpty(payload)) {
    const { timestamp, total, sma7 } = payload[0].payload;

    return (
      <div className="text-xs bg-white dark:bg-gray-800 p-4 rounded-md shadow z-50">
        <div className="font-medium">
          {moment(timestamp).utc().format("ddd MMM Do, HH:mm")}
        </div>
        <div>
          24h total:{" "}
          {displayInCurrency(total || 0, {
            withHntSuffix: true,
            needsDivision: true
          })}
        </div>
        <div>
          7d avg:{" "}
          {displayInCurrency(sma7 || 0, {
            withHntSuffix: true,
            needsDivision: true
          })}
        </div>
      </div>
    );
  }

  return null;
};

export default HistoricalDataChartTooltipWithCurrency;
